import { confirmAlert } from 'react-confirm-alert'
import getText from '../../shared/i18n/labels'

// BUTTONS
import { BtnEmpty } from '../BtnEmpty'
import { ButtonAssistance } from '../form/ButtonAssistance'

/**
 * PopupError è un componente che visualizza un popup di errore con un titolo e un contenuto personalizzabili.
 * Consente anche di specificare un secondo titolo e un pulsante per richiedere assistenza.
 *
 * @param {string} title - Il titolo del popup. Se non specificato, verrà impostato su "Attenzione".
 * @param {string} text - Il contenuto del popup.
 * @param {string} second_title - Un secondo titolo da visualizzare sotto il titolo principale.
 * @param {string} request - Il testo del pulsante per richiedere assistenza.
 * @param {Function} buttonClose - Un pulsante personalizzato da utilizzare per chiudere il popup. Se non specificato, sarà un pulsante predefinito con l'etichetta "Chiudi".
 */
export function PopupError(props) {
  const labels = getText(localStorage.getItem('language') || 'it')

  /**
   * confirm alert è una funzione di react-confirm-alert che mostra un popup
   *
   * @see https://github.com/GA-MO/react-confirm-alert
   *
   */
  return confirmAlert({
    /**
     * customUI è una funzione di callback che restituisce un elemento JSX per il contenuto del popup di conferma dell'avviso.
     *
     * La funzione riceve un oggetto con una singola proprietà, onClose, che è una funzione di callback che dovrebbe essere chiamata quando l'utente vuole chiudere il popup.
     * La funzione dovrebbe restituire un elemento JSX che verrà renderizzato all'interno del popup.
     *
     */
    customUI: ({ onClose }) => {
      const ButtonClose =
        props?.buttonClose ||
        (() => (
          <>
            <BtnEmpty
              text={props?.close || labels.CLOSE || 'Chiudi'}
              classCustom="m-0"
              handlerOnClick={onClose}
            />
          </>
        ))
      return (
        <>
          <div className="bar"></div>
          <div className="popup modal-content">
            <div className="w-100 d-flex justify-content-end">
              <button type="button" className="close" onClick={onClose}>
                <span className="visually-hidden">Close</span>
              </button>
            </div>
            <div className={'row show-grid popup-title-delete text-center'}>
              <div className="col-12">
                <h5>{props?.title || labels.WARNING}</h5>
              </div>
            </div>
            <div className={'row show-grid text-center'}>
              <div className="col-12 d-flex align-items-center flex-column">
                <div dangerouslySetInnerHTML={{ __html: props?.text }}></div>
              </div>
            </div>
            {props?.second_title !== undefined && (
              <div className={'row show-grid text-center'}>
                <div
                  className="col-12 d-flex align-items-center flex-column"
                  dangerouslySetInnerHTML={{ __html: props?.second_title }}></div>
              </div>
            )}

            <div className="d-flex pt-4 justify-content-between">
              <ButtonClose />
              <div className="ms-4">
                <ButtonAssistance className="mb-0" buttonTitle={props?.request} />
              </div>
            </div>
          </div>
        </>
      )
    },
    closeOnClickOutside: false
  })
}

export function closePopupError() {
  const closeButton = document.querySelector('.react-confirm-alert .popup .close')
  if (closeButton) closeButton.click()
}
